<template>
    <div class="detail"  v-drag>
        <div class="head">
            <img :src="currentDevice.deviceImg" class="pic" alt="">
            <div class="data">
                <div style="font-size:18rem;color:rgba(13, 148, 255, 1)">{{currentDevice.deviceName || '设备名称'}}
                </div>
                <div>类型 : {{currentDevice.deviceClassName || ''}}</div>
                <div>型号 : {{currentDevice.deviceModelName || ''}}</div>
            </div>
            <img class="close" src="../../assets/img/关闭.png" alt="" @click="off">
        </div>
        <div class="footer">
            <ExpandTable v-for="(value,key,index) in deviceDetails" :key="index" :name="key"
                :details="value" />
        </div>
    </div>
</template>


<script>
    const ExpandTable = ()=>import('./ExpandTable.vue')
    export default{
        // props:['currentDevice'],
        data(){
            return {
                currentDevice:{}
            }
        },
        components:{
            ExpandTable
        },
        methods:{
            off(){
                this.$emit('offDetails',false)
            }
        },
        computed:{
            deviceDetails(){
                if(Object.keys(this.currentDevice).length > 0){
                    return JSON.parse(this.currentDevice.deviceDetails)
                }
                
            }
        },
        watch:{
            currentDevice(obj){
                console.log(obj);
            }
        }

    }
</script>

<style lang="less" scoped>
    .detail {
        .w(382);
        .h(448);
        position: fixed;
        bottom: 1400/108vh;
        left: 4500/192vw;
        background-image: url(../../assets/img/设备参数.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .head {
            width: 100%;
            .h(134);
            margin-top: 200/108vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 200/108vh 170/192vw 150/108vh;

            .pic {
                .w(96);
                .h(96);
                background: rgba(13, 148, 255, 0.2);
            }

            .data {
                width: 60%;
                .h(96);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                color: #60A9E2;
            }

            .close {
                .w(17);
                .h(17);
                cursor: pointer;
            }
        }

        .footer {
            width: 100%;
            .h(275);
            overflow-y: auto;
        }

        .footer::-webkit-scrollbar{
            width: 3rem;
        }
        .footer::-webkit-scrollbar-thumb{
            border-radius:3rem ;
            background-color: rgba(255, 255, 255, .3);
            height: 2px;

        }
        .footer::-webkit-scrollbar-thumb:hover{
            background-color: rgba(255, 255, 255, 1);
        }
    }
</style>